import React from "react"
import { motion } from "framer-motion"

export default function About() {
  return (
    <section id="about" className="bg-ink text-white border-t border-lineSoft py-20 sm:py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex items-baseline gap-3.5 mb-10">
          <span className="font-mono text-xs text-amber">01</span>
          <h2 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight">About</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10">
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5 }}
            className="text-muted text-[15px] leading-relaxed"
          >
            I'm an IT graduate with a <span className="text-white">BSc (Hons) Computing</span> from
            London Metropolitan University, currently working as an{" "}
            <span className="text-white">L1 Support Associate Team Leader</span> inside an
            international airport environment. My day-to-day involves configuring and
            maintaining CUPPS and BRS systems, keeping boarding-pass and baggage-tag printers
            online, and resolving hardware and software incidents before they become bigger
            problems.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-muted text-[15px] leading-relaxed"
          >
            Outside of airport operations, I build backend systems with{" "}
            <span className="text-white">Node.js, Express, PostgreSQL and Prisma</span>, and
            I've spent time as a network and systems administrator keeping a college campus
            running. I take responsibility for critical systems, coordinate across teams, and
            explain technical issues clearly to non-technical staff — and I'm always looking to
            pick up the next tool or technology.
          </motion.p>
        </div>

        <div className="flex flex-wrap gap-x-10 gap-y-3 mt-12 pt-8 border-t border-lineSoft font-mono text-xs text-muted">
          <div>
            LOCATION <span className="text-white ml-1">Pokhara, Nepal</span>
          </div>
          <div>
            LANGUAGES <span className="text-white ml-1">4 spoken</span>
          </div>
          <div>
            DEGREE <span className="text-white ml-1">BSc (Hons) Computing</span>
          </div>
          <div>
            FOCUS <span className="text-white ml-1">IT Ops · Backend</span>
          </div>
        </div>
      </div>
    </section>
  )
}
